import axiosInstance from "shared/axios";
import { CALLING_INTERFACE_APIS } from "shared/constants";

export const sendNotificationApi = (data) =>{
    let url = `${CALLING_INTERFACE_APIS.send_notification}`
    return axiosInstance.post(url,data)
  }